import type { ReactNode } from "react";
import { useWootric } from "../hooks/useWootric";
import type { WootricUser } from "../types/wootric";

interface WootricProviderProps {
  children: ReactNode;
  user: WootricUser | null;
  enabled?: boolean;
}

export function WootricProvider({
  children,
  user,
  enabled = true,
}: WootricProviderProps) {
  useWootric({ user, enabled });

  return <>{children}</>;
}
